<template>
    <svg :width="width" :height="height" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.125 23.4375H14.0625C14.9268 23.4375 15.625 22.7393 15.625 21.875V18.75H17.1875V21.875C17.1875 23.5986 15.7861 25 14.0625 25H3.125C1.40137 25 0 23.5986 0 21.875V10.9375C0 9.21387 1.40137 7.8125 3.125 7.8125H6.25V9.375H3.125C2.26074 9.375 1.5625 10.0732 1.5625 10.9375V21.875C1.5625 22.7393 2.26074 23.4375 3.125 23.4375ZM10.9375 15.625H21.875C22.7393 15.625 23.4375 14.9268 23.4375 14.0625V3.125C23.4375 2.26074 22.7393 1.5625 21.875 1.5625H10.9375C10.0732 1.5625 9.375 2.26074 9.375 3.125V14.0625C9.375 14.9268 10.0732 15.625 10.9375 15.625ZM7.8125 14.0625V3.125C7.8125 1.40137 9.21387 0 10.9375 0H21.875C23.5986 0 25 1.40137 25 3.125V14.0625C25 15.7861 23.5986 17.1875 21.875 17.1875H10.9375C9.21387 17.1875 7.8125 15.7861 7.8125 14.0625Z" :fill="fill"/>
    </svg>
</template>
<script>
export default {
    name: 'ui-duplicate-icon',
    props: {
        fill: {
            type: String,
            default: '#0C89F6'
        },
        design: {
            type: String,
            default: ''
        },
        width: {
            type: [String, Number],
            default: 25
        },
        height: {
            type: [String, Number],
            default: 25
        }
    }
}
</script>